export const theme = {
  font: {
    family: '"Signika", sans-serif',
    size: '18px',
    height: '20px'
  },
  colors: {
    // white
    // primary: '#746464',
    // primaryLight: '#a39292',
    // primaryDark: '#483a3a',
    // secondary: '#7B7174',
    // secondaryLight: '#aa9fa3',
    // secondaryDart: '#4f4649',
    // background: 'rgb(251, 251, 251)',
    // backgroundLight: '#ffffff',
    // backgroundDark: '#c8c8c8'

    // pink
    background: 'rgb(237, 45, 101)',
    backgroundDark: '#b4003b',
    backgroundLight: '#ff6992',
    primary: '#ffffff',
    primaryDark: '#cccccc',
    primaryLight: '#ffffff',
    secondary: '#ffffff',
    secondaryDart: '#cccccc',
    secondaryLight: '#ffffff'
  },
  breakpoints: {
    mobile: '360px'
  }
}

export type Theme = typeof theme
